import React from 'react';
import {Modal} from '@/ui-kits';
import {Icon} from '@/ui-kits';
import {SecurityPolicyContent} from '../SecurityPolicyContent';

interface SecurityPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SecurityPolicyModal: React.FC<SecurityPolicyModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="relative bg-white items-start py-3 sm:py-5 xs:py-6 md:py-8 px-3 sm:px-4 xs:px-6 md:px-8 lg:px-12 rounded-xl gap-4 box-border w-[95vw] sm:w-[90vw] md:w-[85vw] lg:w-[80vw] xl:w-[75vw] 2xl:w-[70vw] max-w-[1200px] max-h-[90vh] overflow-y-auto mx-auto">
      <button
        className="absolute top-2 right-2 sm:top-3 sm:right-3 md:top-4 md:right-4 z-10"
        onClick={onClose}
        aria-label="Close">
        <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center hover:bg-ui_input_border_dark/20 transition-colors">
          <Icon type="close" className="size-4 sm:size-5 md:size-6 text-ui_blue" />
        </div>
      </button>

      <div className="w-full pr-6 sm:pr-8 md:pr-10">
        <SecurityPolicyContent />
      </div>
    </Modal>
  );
};
